import React from 'react';

import { NotificationSettings } from 'Deer/pages/Company/Settings/Notification/NotificationSettings';
import NotificationsDeer from 'screens/admin/NotificationsDeer';
import { checkSettingsPageRevampEnabled } from 'utils/helpers/featureFlags';

const NotificationsPage = () => {
  const isSettingsPageRevampEnabled = checkSettingsPageRevampEnabled();

  if (isSettingsPageRevampEnabled) return <NotificationSettings isEmployeeNotificationSettings />;

  return <NotificationsDeer isEmployeeNotificationSettings />;
};

export { NotificationsPage };
